import { UISchema } from "@bonusmap/api-types";

export function retrieveOrganization(dataSource: UISchema,
    fieldName: string = "organization_id"): string {
    const organizationsList = window.organizationsList || [];
    const id = dataSource?.[fieldName]?.value;
    if (!id && id!=0) return "";
    const org = organizationsList.find(o => o.id == id);
    if (!org) return "";
    return org.name || "";
}